<template>
    <div class="user-avator-dropdown">
        <Dropdown @on-click="handleClick">
            <Avatar :src="userAvator"/>
            <Icon :size="18" type="md-arrow-dropdown"></Icon>
            <DropdownMenu slot="list">
                <DropdownItem name="editpwd">修改密码</DropdownItem>
                <DropdownItem name="logout">退出登录</DropdownItem>
            </DropdownMenu>
        </Dropdown>
        <!--修改密码对话框-->
        <Modal v-model="editPwdModal" title="修改密码">
            <Form :model="editPwdForm" :label-width="100" :rules="editPwdRule" ref="editPwdForm">
                <FormItem label="旧密码" prop="oldPwd">
                    <Input v-model="editPwdForm.oldPwd" placeholder="请输入旧密码" type="password"/>
                </FormItem>
                <FormItem label="新密码" prop="newPwd">
                    <Input v-model="editPwdForm.newPwd" placeholder="请输入新密码" type="password"/>
                </FormItem>
                <FormItem label="确认密码" prop="newPwd2">
                    <Input v-model="editPwdForm.newPwd2" placeholder="再次输入密码" type="password"/>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="primary" size="small" style="margin-right: 10px;" @click="editPwd('editPwdForm')"
                        :loading="loading">
                    <span v-if="!loading">确定</span>
                    <span v-else>修改中</span>
                </Button>
                <Button type="primary" size="small" @click="editPwdModal=!editPwdModal">取消</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
  import './user.less'
  import {mapActions} from 'vuex'

  export default {
    name: 'User',
    props: {
      userAvator: {
        type: String,
        default: ''
      }
    },
    data(){
      const validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.editPwdForm.newPwd2 !== '') {
            // 对第二个密码框单独验证
            this.$refs.editPwdForm.validateField('newPwd2');
          }
          callback();
        }
      };
      const validatePassCheck = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.editPwdForm.newPwd) {
          callback(new Error('两次输入密码不一致'));
        } else {
          callback();
        }
      };

      return {
        editPwdModal: false,//修改密码对话框
        loading: false,
        //修改密码表单
        editPwdForm: {
          oldPwd: '',
          newPwd: '',
          newPwd2: '',
        },
        //修改密码验证规则
        editPwdRule: {
          oldPwd: [
            {required: true, trigger: 'blur', message: "请输入旧密码"}
          ],
          newPwd: [
            {required: true, trigger: 'blur', validator: validatePass},
            {min: 6, message: '密码需不少于6位', trigger: 'blur'}
          ],
          newPwd2: [
            {required: true, trigger: 'blur', validator: validatePassCheck}
          ]
        },
      };
    },
    methods: {
      ...mapActions([
        'handleLogOut'
      ]),
      handleClick(name) {
        switch (name) {
          case 'editpwd':
            this.$refs['editPwdForm'].resetFields();
            this.editPwdModal = true;
            break
          case 'logout':
            this.handleLogOut().then(() => {
              this.$router.push({
                name: 'login'
              })
            })
            break
        }
      },
      editPwd(name) {
        let self = this;
        self.$refs[name].validate((valid) => {
          if (valid) {
            let param = {
              newpwd: this.editPwdForm.newPwd,
              oldpwd: this.editPwdForm.oldPwd
            }
            this.$api.user.editPwd(param).then(res => {
              if (res.state == "ok") {
                this.$Message.success("修改成功,请重新登录")
                this.handleLogOut().then(() => {
                  this.$router.push({
                    name: 'login'
                  })
                })
              } else {
                this.editPwdModal = false
                this.loading = false
                this.$Message.error(res.msg)
              }
            })
          }
        })
      }
    }
  }
</script>
